import { selectShippingRegionCountryCodeIso2 } from 'tradera-state/shipping-region/selectors';

export const selectTranslatedReviews = state =>
    state.views.profile.translatedReviews;

export const selectTranslatedReview = feedbackId => state =>
    showTranslatedReviews(state) &&
    selectTranslatedReviews(state).find(
        ({ gradeId }) => gradeId === feedbackId
    );

export const selectHasTranslatedReview = feedbackId => state =>
    !!selectTranslatedReview(feedbackId)(state)?.text ||
    !!selectTranslatedReview(feedbackId)(state)?.reply;

export const showLoading = state =>
    state.views.profile.translatedReviewsLoading;

export const showError = state =>
    state.views.profile.translatedReviewsLoadingError;

export const selectIsTranslationOnDemandDisabled = state =>
    state.views.profile.isTranslationOnDemandDisabled;

export const showTranslatedReviews = state =>
    state.views.profile.showTranslatedReviews;

export const selectProfileFeedbackModel = state => state.views.profile.model;

export const selectFeedbackItemsIds = state =>
    selectProfileFeedbackModel(state)?.feedbackItems.map(
        ({ gradeId }) => gradeId
    );

export const selectIsTranslateable = feedbackId => state =>
    selectProfileFeedbackModel(state)
        ?.feedbackItems.filter(
            ({ feedbackMemberCountryCodeIso2 }) =>
                feedbackMemberCountryCodeIso2.toLowerCase() !==
                selectShippingRegionCountryCodeIso2(state).toLowerCase()
        )
        .find(({ gradeId }) => gradeId === feedbackId);

export const selectHasTranslateableFeedbackItems = state =>
    selectProfileFeedbackModel(state)?.feedbackItems.some(
        ({ feedbackMemberCountryCodeIso2 }) =>
            feedbackMemberCountryCodeIso2?.toLowerCase() !==
            selectShippingRegionCountryCodeIso2(state).toLowerCase()
    );

export const selectIsLoadingFeedbackModel = state =>
    state.views.profile.loadingModel;
